export const THEMES = {
  ROCHE: 'roche',
  ORACLE: 'oracle',
  SENDSPARK: 'sendspark',
  SENSDPARK_LEGACY: 'sendspark-legacy',
  APM: 'apm',
};

export const ANALYTICS_TITLE = {
  CampaignView: 'Campaign Viewed',
  CampaignVideoPlay: 'Campaign Video Played',
  CampaignResponseClick: 'Campaign Response Clicked',
  CampaignCtaClick: 'Campaign CTA Clicked',
  CampaignVideoEnded: 'Campaign Video Ended',
  ViralLinkClick: 'Viral Link Clicked',
  CampaignVideoLike: 'Campaign Video Liked',
  VideoViewReceived: 'Video View Received',
  ViewGot: 'View Got',
  CtaCovensionGot: 'Video CTA Conversion Received',
};

export const SCRIPT_GENERATOR_TABS = {
  SCRIPT: 'script',
  EMAIL: 'email',
};

export const MUX_STATUS = {
  PREPARING: 'preparing',
  READY: 'ready',
};

export const COOKIE_KEYS = {
  CURRENT_WORKSPACE: 'current_workspace',
  USER_ID: 'user_id',
  SENDSPARK_JWT: 'sendspark_jwt',
  WORKOS_SESSION: 'wos-session',
};

export const LOCAL_STORAGE_KEYS = {
  USER_SESSION_ID: 'aVfW9qLwQVTO',
};

export enum SharePreviewTypes {
  Template = 'template',
  Campaign = 'campaign',
  DynamicVideo = 'dynamic-video',
  Workspace = 'workspace',
}

export const CALENDAR_PROVIDERS = {
  LEMCAL: 'lemcal-embed-booking-calendar',
};

export const CALENDAR_CUSTOM_LAYOUTS = {
  [CALENDAR_PROVIDERS.LEMCAL]: {
    Right: 'LemcalRight',
    Main: 'LemcalMain',
  },
};

export const MEDIA_QUALITY = {
  VIDEO_BITRATE: 2500000, // 2.5 Mbps for HD quality
  AUDIO_BITRATE: 128000, // 128 kbps for audio
};

export const OPTIMAL_IOS_FRAME_RATE = 30; // Maximum stable frame rate for iOS devices
